
import { Vue } from "vue-class-component";
export default class MainLoading extends Vue {}
